import React from "react";
import "./ClassificationPage.css";
import classImg from "asset/image/NFT_CLASS_IMAGE.jpg";
import classImg800 from "asset/image/NFT_CLASS_IMAGE_800.jpg";

import {useTranslation} from "react-i18next";
import {useMediaQuery} from "react-responsive";
function ClassificationPage(props) {
    const imgMinWidth = useMediaQuery({minWidth:720})
    function ClassficationImg() {
        const img = imgMinWidth ? classImg : classImg800;
        return (
            <img src={img} width={"100%"}/>
        )
    }
    const { t } = useTranslation();
    return (
        <div className={"classification-page"}>
            <div className={"classification-container"}>
                <div className={"classification-header"}>
                    {/* 타이틀 */}
                    <h2>NFT Class</h2>
                    <p className={"nftimg-guide"}>{t('NFTIMG_GUIDE')}</p>
                </div>
                <div className={"classification-content"}>
                    {ClassficationImg()}
                </div>
            </div>
        </div>
    )
}

export default ClassificationPage;